export var RatingsSize;
(function (RatingsSize) {
    RatingsSize["Small"] = "small";
    RatingsSize["Large"] = "large";
})(RatingsSize || (RatingsSize = {}));
export var RatingsMode;
(function (RatingsMode) {
    RatingsMode["Input"] = "input";
    RatingsMode["Display"] = "display";
})(RatingsMode || (RatingsMode = {}));
export var RatingsLayout;
(function (RatingsLayout) {
    RatingsLayout["Aside"] = "aside";
    RatingsLayout["Bottom"] = "bottom";
})(RatingsLayout || (RatingsLayout = {}));
export var RatingsLabelPlacement;
(function (RatingsLabelPlacement) {
    RatingsLabelPlacement["Top"] = "top";
    RatingsLabelPlacement["Aside"] = "aside";
})(RatingsLabelPlacement || (RatingsLabelPlacement = {}));
export var RatingsDataHooks;
(function (RatingsDataHooks) {
    RatingsDataHooks["RatingContainer"] = "rating-container";
    RatingsDataHooks["IconWrapper"] = "icon-wrapper";
    RatingsDataHooks["InputOption"] = "input-option";
    RatingsDataHooks["InputOptionCurrent"] = "current-input-option";
    RatingsDataHooks["RatingInfo"] = "rating-info";
    RatingsDataHooks["RatingLabel"] = "rating-label";
})(RatingsDataHooks || (RatingsDataHooks = {}));
export var RatingsDataKeys;
(function (RatingsDataKeys) {
    RatingsDataKeys["Error"] = "data-error";
    RatingsDataKeys["Disabled"] = "data-disabled";
    RatingsDataKeys["Size"] = "data-size";
    RatingsDataKeys["Hovered"] = "data-hovered";
})(RatingsDataKeys || (RatingsDataKeys = {}));
//# sourceMappingURL=types.js.map